import React from 'react';
import { motion } from 'framer-motion';

/* ───────────────────────────────────────────────────────────────
   Asset placeholder — a labeled block standing in for a real image,
   screen, or motion clip. Tells Sami exactly what asset goes here.
   ─────────────────────────────────────────────────────────────── */
export function Placeholder({ label, tag = 'asset', ratio = '16 / 10', dim, className = '' }) {
  return (
    <div
      className={`pp-ph ${className}`}
      style={{ aspectRatio: ratio }}
    >
      <span className="pp-ph__tag">{tag}</span>
      <svg className="pp-ph__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2.5" y="4" width="19" height="16" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
        <circle cx="8" cy="9.5" r="1.6" stroke="currentColor" strokeWidth="1.3" />
        <path d="M3.5 17l5-4.5 3.5 3 4-3.5 4.5 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="pp-ph__label">{label}</span>
      {dim && <span className="pp-ph__dim">{dim}</span>}
    </div>
  );
}

/* Inline marker for a real number / fact Sami still needs to supply */
export function Fill({ children }) {
  return <span className="pp-fill">{children}</span>;
}

/* ───────────────────────────────────────────────────────────────
   Reveal — restrained scroll-in. One shared motion vocabulary so
   the whole portfolio moves the same calm way.
   ─────────────────────────────────────────────────────────────── */
export function Reveal({ children, delay = 0, y = 24, className = '', as = 'div' }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </MotionTag>
  );
}
